module.exports = __webpack_public_path__ + "img/download_code.eaed00d5.png";